export const STATE_NOMINAL = 'STATE_NOMINAL'
export const STATE_FETCHING = 'STATE_FETCHING'
export const STATE_ERROR = 'STATE_ERROR'
export const STATE_DONE = 'STATE_DONE'

export const QA_STATUS_PENDING = 'PENDING'
export const QA_STATUS_GOOD = 'GOOD'
export const QA_STATUS_BAD = 'BAD'

export type QAStatus = ('PENDING' | 'GOOD' | 'BAD')
